import {Stack, styled} from '@mui/material';

export const StyledContainer = styled(Stack)`
	height: 50px;
	width: 100%;
	background-color: #f5f5f5;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding-left: 8px;
	padding-right: 16px;
	padding-top: 5px;
	padding-bottom: 5px;
`;

export const StyledContent = styled(Stack)`
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

export const StyledIcon = styled(Stack)(() => ({
	overflow: 'hidden',
	borderRadius: '8px',
	marginLeft: '8px',
	marginRight: '8px',
}));
